/*
<summary>
   This higher-order component is all about wrapping a component with Add/Edit Tool Management popup visibility state and its toggle handler.
   Developer: Aashish Singh, Created Date: 20-Aug-2026
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/

import { useState } from 'react';

const AddEditToolManagementPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddToolManagementPopup, setShowAddToolManagementPopup] =
      useState<boolean>(false);

    const addToggleHandler = () => {
      setShowAddToolManagementPopup(!showAddToolManagementPopup);
    };

    return (
      <Component
        showAddToolManagementPopup={showAddToolManagementPopup}
        addToggleHandler={addToggleHandler}
        {...props}
      />
    );
  };

export default AddEditToolManagementPopupHOC;
